module.exports = __webpack_public_path__ + "static/p14_burrito-e7abcdc9ecd78835c0ac18bde65da27e.png";